import { createAction } from "@reduxjs/toolkit";
import axios from "axios";
import { call, put, takeEvery } from "redux-saga/effects";

import {
  FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST,
  FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED,
  FETCHING_ADVOCACY_SHARES_FAILED,
  FETCHING_ADVOCACY_SHARES_SUCCEEDED,
  FETCHING_ADVOCACY_TIME_SPENT_FAILED,
  FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED,
  FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED,
  FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED,
  FETCHING_ADVOCACY_TOP_SHARERS_FAILED,
  FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED,
  FETCHING_ADVOCACY_VIEWS_FAILED,
  FETCHING_ADVOCACY_VIEWS_SUCCEEDED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED,
  FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED,
  FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED,
  FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST,
  FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED,
  FETCHING_DISCOVERY_POPULAR_ASSETS,
  FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED,
  FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_QUERIES,
  FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED,
  FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED,
  FETCHING_DISCOVERY_SEARCH_TAGS,
  FETCHING_DISCOVERY_SEARCH_TAGS_FAILED,
  FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_SHARERS,
  FETCHING_DISCOVERY_TOP_SHARERS_FAILED,
  FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED,
  FETCHING_DISCOVERY_TOP_USERS,
  FETCHING_DISCOVERY_TOP_USERS_FAILED,
  FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED,
  FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED,
  FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED,
  FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED,
  FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED,
  FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED,
  FETCHING_ENGAGEMENT_TOP_USERS,
  FETCHING_ENGAGEMENT_TOP_USERS_FAILED,
  FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED,
  FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED,
  FETCHING_LEADS_DETAIL_REPORT,
  FETCHING_LEADS_DETAIL_REPORT_FAILED,
  FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_DEALS_FAILED,
  FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEALS_SUCCEEDED,
  FETCHING_PERFORMANCE_DEAL_VALUE_FAILED,
  FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT,
  FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED,
  FETCHING_PERFORMANCE_INTERACTIONS_FAILED,
  FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED,
  FETCHING_PERFORMANCE_LEADS_FAILED,
  FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT,
  FETCHING_PERFORMANCE_LEADS_SUCCEEDED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED,
  FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED,
  FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED,
  FETCH_ADVOCACY_SHARES,
  FETCH_ADVOCACY_TIME_SPENT,
  FETCH_ADVOCACY_TOP_SHARED_ASSETS,
  FETCH_ADVOCACY_TOP_SHARERS,
  FETCH_ADVOCACY_TOP_USER_GROUPS,
  FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED,
  FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED,
  FETCH_ADVOCACY_VIEWS,
  INTIALIZING_DOWNLOAD_REPORT_FAILED,
  INTIALIZING_DOWNLOAD_REPORT_REQUEST,
  INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED,
  INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS,
  INVALIDATE_REPORTS_DOWNLOAD_DATA,
  FETCH_ADVOCACY_TOP_ENGAGED_ASSETS,
  FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED,
  FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED,
  FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED,
  FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED,
  FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED
} from "./actionTypes";
import {
  FetchAdvocacyShareGraphReportErrorResponse,
  FetchAdvocacyShareGraphReportRequest,
  FetchAdvocacyShareGraphReportResponse,
  FetchAdvocacyTimeSpentGraphReport,
  FetchAdvocacyTopEngagedAssetsErrorResponse,
  FetchAdvocacyTopEngagedAssetsRequest,
  FetchAdvocacyTopEngagedAssetsResponse,
  FetchAdvocacyTopSharedAssetsErrorResponse,
  FetchAdvocacyTopSharedAssetsRequest,
  FetchAdvocacyTopSharedAssetsResponse,
  FetchAdvocacyTopSharersErrorResponse,
  FetchAdvocacyTopSharersRequest,
  FetchAdvocacyTopSharersResponse,
  FetchAdvocacyTopUserGroupsErrorResponse,
  FetchAdvocacyTopUserGroupsRequest,
  FetchAdvocacyTopUserGroupsResponse,
  FetchAdvocacyViewsGraphReportRequest,
  FetchDiscoveryAssetViewsGraphReportErrorResponse,
  FetchDiscoveryAssetViewsGraphReportRequest,
  FetchDiscoveryAssetViewsGraphReportResponse,
  FetchDiscoveryAssetsGraphReportErrorResponse,
  FetchDiscoveryAssetsGraphReportRequest,
  FetchDiscoveryAssetsGraphReportResponse,
  FetchDiscoveryAssetsSharedErrorResponse,
  FetchDiscoveryAssetsSharedRequest,
  FetchDiscoveryAssetsSharedResponse,
  FetchDiscoveryCollectionActivityGraphErrorResponse,
  FetchDiscoveryCollectionActivityGraphRequest,
  FetchDiscoveryCollectionActivityGraphResponse,
  FetchDiscoveryCollectionsErrorResponse,
  FetchDiscoveryCollectionsRequest,
  FetchDiscoveryCollectionsResponse,
  FetchDiscoveryCollectionsSharedErrorResponse,
  FetchDiscoveryCollectionsSharedRequest,
  FetchDiscoveryCollectionsSharedResponse,
  FetchDiscoveryContentMatrixAssetsErrorResponse,
  FetchDiscoveryContentMatrixAssetsRequest,
  FetchDiscoveryContentMatrixAssetsResponse,
  FetchDiscoveryContentMatrixErrorResponse,
  FetchDiscoveryContentMatrixRequest,
  FetchDiscoveryContentMatrixResponse,
  FetchDiscoveryPopularAssetsErrorResponse,
  FetchDiscoveryPopularAssetsRequest,
  FetchDiscoveryPopularAssetsResponse,
  FetchDiscoverySearchQueriesErrorResponse,
  FetchDiscoverySearchQueriesRequest,
  FetchDiscoverySearchQueriesResponse,
  FetchDiscoverySearchTagsErrorResponse,
  FetchDiscoverySearchTagsRequest,
  FetchDiscoverySearchTagsResponse,
  FetchDiscoveryShareGraphReportErrorResponse,
  FetchDiscoveryShareGraphReportRequest,
  FetchDiscoveryShareGraphReportResponse,
  FetchDiscoveryTopSharesErrorResponse,
  FetchDiscoveryTopSharesRequest,
  FetchDiscoveryTopSharesResponse,
  FetchDiscoveryTopUsersErrorResponse,
  FetchDiscoveryTopUsersRequest,
  FetchDiscoveryTopUsersResponse,
  FetchEnagagementShareReportErrorResponse,
  FetchEnagagementShareReportRequest,
  FetchEnagagementShareReportResponse,
  FetchEngagementAssetViewsGraphErrorResponse,
  FetchEngagementAssetViewsGraphRequest,
  FetchEngagementAssetViewsGraphResponse,
  FetchEngagementAttentionTimeGraphErrorResponse,
  FetchEngagementAttentionTimeGraphRequest,
  FetchEngagementAttentionTimeGraphResponse,
  FetchEngagementCollectionReportErrorResponse,
  FetchEngagementCollectionReportRequest,
  FetchEngagementCollectionReportResponse,
  FetchEngagementTopAccountsErrorResponse,
  FetchEngagementTopAccountsRequest,
  FetchEngagementTopAccountsResponse,
  FetchEngagementTopCampaignsErrorResponse,
  FetchEngagementTopCampaignsRequest,
  FetchEngagementTopCampaignsResponse,
  FetchEngagementTopCampaignsSourcesErrorResponse,
  FetchEngagementTopCampaignsSourcesRequest,
  FetchEngagementTopCampaignsSourcesResponse,
  FetchEngagmentPopularAssetsErrorResponse,
  FetchEngagmentPopularAssetsRequest,
  FetchEngagmentPopularAssetsResponse,
  FetchEngagmentShareGraphErrorResponse,
  FetchEngagmentShareGraphRequest,
  FetchEngagmentShareGraphResponse,
  FetchEngagmentTopUsersErrorResponse,
  FetchEngagmentTopUsersRequest,
  FetchEngagmentTopUsersResponse,
  FetchEngagmentUniqueViewersGraphErrorResponse,
  FetchEngagmentUniqueViewersGraphRequest,
  FetchEngagmentUniqueViewersGraphResponse,
  FetchPerformanceClosedDealGraphErrorResponse,
  FetchPerformanceClosedDealGraphRequest,
  FetchPerformanceClosedDealGraphResponse,
  FetchPerformanceClosedDealValueGraphErrorResponse,
  FetchPerformanceClosedDealValueGraphRequest,
  FetchPerformanceClosedDealValueGraphResponse,
  FetchPerformanceDealValueGraphErrorResponse,
  FetchPerformanceDealValueGraphRequest,
  FetchPerformanceDealValueGraphResponse,
  FetchPerformanceDealsGraphErrorResponse,
  FetchPerformanceDealsGraphRequest,
  FetchPerformanceDealsGraphResponse,
  FetchPerformanceInteractionsGraphErrorResponse,
  FetchPerformanceInteractionsGraphRequest,
  FetchPerformanceInteractionsGraphResponse,
  FetchPerformanceLeadsGraphErrorResponse,
  FetchPerformanceLeadsGraphRequest,
  FetchPerformanceLeadsGraphResponse,
  FetchPerformanceTopContentLeadsErrorResponse,
  FetchPerformanceTopContentLeadsRequest,
  FetchPerformanceTopContentLeadsResponse,
  FetchReportSummaryNudgesErrorResponse,
  FetchReportSummaryNudgesRequest,
  FetchReportSummaryNudgesResponse,
  FetchingAdvocacyTimeSpentGraphReportFailed,
  FetchingAdvocacyTimeSpentGraphReportSucceeded,
  FetchingAdvocacyViewsGraphReportFailed,
  FetchingAdvocacyViewsGraphReportSucceeded,
  FetchDiscoveryDealRoomsRequest,
  FetchDiscoveryDealRoomsResponse,
  FetchDiscoveryDealRoomsErrorResponse,
  FetchDiscoveryDealRoomsSharedRequest,
  FetchDiscoveryDealRoomsSharedResponse,
  FetchDiscoveryDealRoomsSharedErrorResponse,
  FetchEngagementDealRoomReportRequest,
  FetchEngagementDealRoomReportResponse,
  FetchEngagementDealRoomReportErrorResponse
} from "src/types/reports";
import buildUrl from "build-url-ts";

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const REPORT_BASE_URL = `${apiUrl}/api/2.0/reports`;
const REPORT_FILTER_BASE_URL = `${apiUrl}/api/2.0/reports/filter`;

//Fetching popular assets 
export const fetchDiscoveryPopularAssets = createAction<FetchDiscoveryPopularAssetsRequest>(FETCHING_DISCOVERY_POPULAR_ASSETS);
const fetchingDiscoveryPopularAssetsSuccedded = createAction<FetchDiscoveryPopularAssetsResponse>(FETCHING_DISCOVERY_POPULAR_ASSETS_SUCCEDDED);
const fetchingDiscoveryPopularAssetsFailed = createAction<FetchDiscoveryPopularAssetsErrorResponse>(FETCHING_DISCOVERY_POPULAR_ASSETS_FAILED);

const fetchDiscoveryPopularAssetsSaga = function* (action: ReturnType<typeof fetchDiscoveryPopularAssets>): any {
  const { page, filter, limit } = action.payload;

  const url = `${REPORT_BASE_URL}/discovery/popular-assets`;

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryPopularAssetsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryPopularAssetsSagaAPI);
    yield put(fetchingDiscoveryPopularAssetsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryPopularAssetsFailed({ error: error }));
  }
};


//Fetching account metrics
export const fetchReportSummaryNudges = createAction<FetchReportSummaryNudgesRequest>(FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST);
const fetchingReportSummaryNudgesSuccedded = createAction<FetchReportSummaryNudgesResponse>(FETCHING_ACCOUNT_SUMMARY_NUDGES_SUCCEDDED);
const fetchingReportSummaryNudgesFailed = createAction<FetchReportSummaryNudgesErrorResponse>(FETCHING_ACCOUNT_SUMMARY_NUDGES_FAILED);

const fetchReportsSummaryNudgesSaga = function* (action: ReturnType<typeof fetchReportSummaryNudges>): any {
  const { nudgesType } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `account/${nudgesType}/summary`,
  });

  const fetchReportsSummaryNudgesSagaAPI = () => {
    return axios({
      method: "GET",
      url: url,

    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchReportsSummaryNudgesSagaAPI);
    yield put(fetchingReportSummaryNudgesSuccedded({ response, nudgesType }));
  } catch (error) {
    yield put(fetchingReportSummaryNudgesFailed({ error: error }));
  }
};

//Fetching popular assets 
export const fetchDiscoveryAssetsShared = createAction<FetchDiscoveryAssetsSharedRequest>(FETCHING_DISCOVERY_ASSETS_SHARED_REPORT);
const fetchingDiscoveryAssetsSharedSuccedded = createAction<FetchDiscoveryAssetsSharedResponse>(FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_SUCCEDDED);
const fetchingDiscoveryAssetsSharedFailed = createAction<FetchDiscoveryAssetsSharedErrorResponse>(FETCHING_DISCOVERY_ASSETS_SHARED_REPORT_FAILED);

const fetchDiscoverAssetsSharedSaga = function* (action: ReturnType<typeof fetchDiscoveryAssetsShared>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/assets_shared`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoverAssetsSharedSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoverAssetsSharedSagaAPI);
    yield put(fetchingDiscoveryAssetsSharedSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryAssetsSharedFailed({ error: error }));
  }
};

//Fetching discovery top users 
export const fetchDiscoveryTopUsers = createAction<FetchDiscoveryTopUsersRequest>(FETCHING_DISCOVERY_TOP_USERS);
const fetchingDiscoveryTopUsersSuccedded = createAction<FetchDiscoveryTopUsersResponse>(FETCHING_DISCOVERY_TOP_USERS_SUCCEDDED);
const fetchingDiscoveryTopUsersFailed = createAction<FetchDiscoveryTopUsersErrorResponse>(FETCHING_DISCOVERY_TOP_USERS_FAILED);

const fetchDiscoveryTopUsersSaga = function* (action: ReturnType<typeof fetchDiscoveryTopUsers>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/top-users`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryTopUsersSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryTopUsersSagaAPI);
    yield put(fetchingDiscoveryTopUsersSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryTopUsersFailed({ error: error }));
  }
};

//Fetching discovery top shares 
export const fetchDiscoveryTopShares = createAction<FetchDiscoveryTopSharesRequest>(FETCHING_DISCOVERY_TOP_SHARERS);
const fetchingDiscoveryTopSharesSuccedded = createAction<FetchDiscoveryTopSharesResponse>(FETCHING_DISCOVERY_TOP_SHARERS_SUCCEEDED);
const fetchingDiscoveryTopSharesFailed = createAction<FetchDiscoveryTopSharesErrorResponse>(FETCHING_DISCOVERY_TOP_SHARERS_FAILED);

const fetchDiscoveryTopSharesSaga = function* (action: ReturnType<typeof fetchDiscoveryTopShares>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/top-sharers`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryTopSharesSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryTopSharesSagaAPI);
    yield put(fetchingDiscoveryTopSharesSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryTopSharesFailed({ error: error }));
  }
};

//Fetching discovery top user groups 
export const fetchDiscoveryTopUserGroups = createAction<FetchDiscoveryTopUsersRequest>(FETCHING_DISCOVERY_TOP_USER_GROUPS);
const fetchingDiscoveryTopUserGroupsSuccedded = createAction<FetchDiscoveryTopUsersResponse>(FETCHING_DISCOVERY_TOP_USER_GROUPS_SUCCEDDED);
const fetchingDiscoveryTopUserGroupsFailed = createAction<FetchDiscoveryTopUsersErrorResponse>(FETCHING_DISCOVERY_TOP_USER_GROUPS_FAILED);

const fetchDiscoveryTopUserGroupsSaga = function* (action: ReturnType<typeof fetchDiscoveryTopUserGroups>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/top-user-groups`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryTopUserGroupsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryTopUserGroupsSagaAPI);
    yield put(fetchingDiscoveryTopUserGroupsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryTopUserGroupsFailed({ error: error }));
  }
};

//Fetching discovery collections 
export const fetchDiscoveryCollections = createAction<FetchDiscoveryCollectionsRequest>(FETCHING_DISCOVERY_COLLECTIONS_REPORT);
const fetchingDiscoveryCollectionsSuccedded = createAction<FetchDiscoveryCollectionsResponse>(FETCHING_DISCOVERY_COLLECTIONS_REPORT_SUCCEDDED);
const fetchingDiscoveryCollectionsFailed = createAction<FetchDiscoveryCollectionsErrorResponse>(FETCHING_DISCOVERY_COLLECTIONS_REPORT_FAILED);

const fetchDiscoveryCollectionsSaga = function* (action: ReturnType<typeof fetchDiscoveryCollections>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/collections`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryCollectionsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryCollectionsSagaAPI);
    yield put(fetchingDiscoveryCollectionsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryCollectionsFailed({ error: error }));
  }
};

//Fetching discovery collections shared
export const fetchDiscoveryCollectionsShared = createAction<FetchDiscoveryCollectionsSharedRequest>(FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT);
const fetchingDiscoveryCollectionsSharedSuccedded = createAction<FetchDiscoveryCollectionsSharedResponse>(FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_SUCCEDDED);
const fetchingDiscoveryCollectionsSharedFailed = createAction<FetchDiscoveryCollectionsSharedErrorResponse>(FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT_FAILED);

const fetchDiscoveryCollectionsSharedSaga = function* (action: ReturnType<typeof fetchDiscoveryCollectionsShared>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/collections_shared`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryCollectionsSharedSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryCollectionsSharedSagaAPI);
    yield put(fetchingDiscoveryCollectionsSharedSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryCollectionsSharedFailed({ error: error }));
  }
};

//Fetching discovery queries
export const fetchDiscoverySearchQueries = createAction<FetchDiscoverySearchQueriesRequest>(FETCHING_DISCOVERY_SEARCH_QUERIES);
const fetchingDiscoverySearchQueriesSuccedded = createAction<FetchDiscoverySearchQueriesResponse>(FETCHING_DISCOVERY_SEARCH_QUERIES_SUCCEDDED);
const fetchingDiscoverySearchQueriesFailed = createAction<FetchDiscoverySearchQueriesErrorResponse>(FETCHING_DISCOVERY_SEARCH_QUERIES_FAILED);

const fetchDiscoverySearchQueriesSaga = function* (action: ReturnType<typeof fetchDiscoverySearchQueries>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/search-query`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoverySearchQueriesSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoverySearchQueriesSagaAPI);
    yield put(fetchingDiscoverySearchQueriesSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoverySearchQueriesFailed({ error: error }));
  }
};

//Fetching discovery search tags
export const fetchDiscoverySearchTags = createAction<FetchDiscoverySearchTagsRequest>(FETCHING_DISCOVERY_SEARCH_TAGS);
const fetchingDiscoverySearchTagsSuccedded = createAction<FetchDiscoverySearchTagsResponse>(FETCHING_DISCOVERY_SEARCH_TAGS_SUCCEDDED);
const fetchingDiscoverySearchTagsFailed = createAction<FetchDiscoverySearchTagsErrorResponse>(FETCHING_DISCOVERY_SEARCH_TAGS_FAILED);

const fetchDiscoverySearchTagsSaga = function* (action: ReturnType<typeof fetchDiscoverySearchTags>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/tags`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoverySearchTagsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoverySearchTagsSagaAPI);
    yield put(fetchingDiscoverySearchTagsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoverySearchTagsFailed({ error: error }));
  }
};

//Fetching discovery asset views graph 
export const fetchDiscoveryAssetViewsGraphReport = createAction<FetchDiscoveryAssetViewsGraphReportRequest>(FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT);
const fetchingDiscoveryAssetViewsGraphReportSuccedded = createAction<FetchDiscoveryAssetViewsGraphReportResponse>(FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED);
const fetchingDiscoveryAssetViewsGraphReportFailed = createAction<FetchDiscoveryAssetViewsGraphReportErrorResponse>(FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT_FAILED);

const fetchDiscoveryAssetViewsGraphReportSaga = function* (action: ReturnType<typeof fetchDiscoveryAssetViewsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/asset_views/graph`,
  });

  const fetchDiscoveryAssetViewsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryAssetViewsGraphReportSagaAPI);
    yield put(fetchingDiscoveryAssetViewsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryAssetViewsGraphReportFailed({ error: error }));
  }
};

//Fetching discovery asset count graph 
export const fetchDiscoveryAssetsGraphReport = createAction<FetchDiscoveryAssetsGraphReportRequest>(FETCHING_DISCOVERY_ASSET_GRAPH_REPORT);
const fetchingDiscoveryAssetsGraphReportSuccedded = createAction<FetchDiscoveryAssetsGraphReportResponse>(FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_SUCCEDDED);
const fetchingDiscoveryAssetsGraphReportFailed = createAction<FetchDiscoveryAssetsGraphReportErrorResponse>(FETCHING_DISCOVERY_ASSET_GRAPH_REPORT_FAILED);

const fetchDiscoveryAssetsGraphReportSaga = function* (action: ReturnType<typeof fetchDiscoveryAssetsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/assets/graph`,
  });

  const fetchDiscoveryAssetsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryAssetsGraphReportSagaAPI);
    yield put(fetchingDiscoveryAssetsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryAssetsGraphReportFailed({ error: error }));
  }
};

//Fetching discovery collection activity graph 
export const fetchDiscoveryCollectionActivityGraphReport = createAction<FetchDiscoveryCollectionActivityGraphRequest>(FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT);
const fetchingDiscoveryCollectionActivityGraphReportSuccedded = createAction<FetchDiscoveryCollectionActivityGraphResponse>(FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_SUCCEDDED);
const fetchingDiscoveryCollectionActivityGraphReportFailed = createAction<FetchDiscoveryCollectionActivityGraphErrorResponse>(FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT_FAILED);

const fetchDiscoveryCollectionActivityGraphReportSaga = function* (action: ReturnType<typeof fetchDiscoveryCollectionActivityGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/collection-activity/graph`,
  });

  const fetchDiscoveryCollectionActivityGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryCollectionActivityGraphReportSagaAPI);
    yield put(fetchingDiscoveryCollectionActivityGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryCollectionActivityGraphReportFailed({ error: error }));
  }
};

//Fetching discovery shares graph 
export const fetchDiscoveryShareGraphReport = createAction<FetchDiscoveryShareGraphReportRequest>(FETCHING_DISCOVERY_SHARE_GRAPH_REPORT);
const fetchingDiscoveryShareGraphReportSuccedded = createAction<FetchDiscoveryShareGraphReportResponse>(FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_SUCCEDDED);
const fetchingDiscoveryShareGraphReportFailed = createAction<FetchDiscoveryShareGraphReportErrorResponse>(FETCHING_DISCOVERY_SHARE_GRAPH_REPORT_FAILED);

const fetchDiscoveryShareGraphReportSaga = function* (action: ReturnType<typeof fetchDiscoveryShareGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/share/graph`,
  });

  const fetchDiscoveryShareGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryShareGraphReportSagaAPI);
    yield put(fetchingDiscoveryShareGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryShareGraphReportFailed({ error: error }));
  }
};

//Fetching discovery content matrix Assets
export const fetchDiscoveryContentMatrxAssets = createAction<FetchDiscoveryContentMatrixAssetsRequest>(FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST);
const fetchingDiscoveryContentMatrxAssetsSuccedded = createAction<FetchDiscoveryContentMatrixAssetsResponse>(FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_SUCCEDDED);
const fetchingDiscoveryContentMatrxAssetsFailed = createAction<FetchDiscoveryContentMatrixAssetsErrorResponse>(FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_FAILED);

const fetchDiscoveryContentMatrxAssetsSaga = function* (action: ReturnType<typeof fetchDiscoveryContentMatrxAssets>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/content-matrix/assets`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryContentMatrxAssetsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter,
      params: params
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryContentMatrxAssetsSagaAPI);
    yield put(fetchingDiscoveryContentMatrxAssetsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryContentMatrxAssetsFailed({ error: error }));
  }
};

export const invalidateDiscoveryContentMatrixAssets = createAction<void>(
  INVALIDATE_DISCOVERY_CONTENT_MATRIX_ASSETS
);

//Fetching discovery content matrix
export const fetchDiscoveryContentMatrix = createAction<FetchDiscoveryContentMatrixRequest>(FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST);
const fetchingDiscoveryContentMatrixSuccedded = createAction<FetchDiscoveryContentMatrixResponse>(FETCHING_DISCOVERY_CONTENT_MATRIX_SUCCEDDED);
const fetchingDiscoveryContentMatrixFailed = createAction<FetchDiscoveryContentMatrixErrorResponse>(FETCHING_DISCOVERY_CONTENT_MATRIX_FAILED);

const fetchDiscoveryContentMatrixSaga = function* (action: ReturnType<typeof fetchDiscoveryContentMatrix>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/content-matrix`,
  });

  const fetchDiscoveryContentMatrixSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryContentMatrixSagaAPI);
    yield put(fetchingDiscoveryContentMatrixSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryContentMatrixFailed({ error: error }));
  }
};

//fetching engagement attention time graph
export const fetchEngagementAttentionTimeGraphReport = createAction<FetchEngagementAttentionTimeGraphRequest>(FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT);
const fetchingEngagementAttentionTimeGraphReportSuccedded = createAction<FetchEngagementAttentionTimeGraphResponse >(FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_SUCCEDDED);
const fetchingEngagementAttentionTimeGraphReportFailed = createAction<FetchEngagementAttentionTimeGraphErrorResponse>(FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT_FAILED);

const fetchEngagementAttentionTimeGraphReportSaga = function* (action: ReturnType<typeof fetchEngagementAttentionTimeGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/attention-time/graph`,
  });

  const fetchEngagementAttentionTimeGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementAttentionTimeGraphReportSagaAPI);
    yield put(fetchingEngagementAttentionTimeGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementAttentionTimeGraphReportFailed({ error: error }));
  }
};

//Fetching engagement unique viewers graph
export const fetchEngagementUniqueViewersGraphReport = createAction<FetchEngagmentUniqueViewersGraphRequest>(FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT);
const fetchingEngagementUniqueViewersGraphReportSuccedded = createAction<FetchEngagmentUniqueViewersGraphResponse>(FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_SUCCEDDED);
const fetchingEngagementUniqueViewersGraphReportFailed = createAction<FetchEngagmentUniqueViewersGraphErrorResponse>(FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT_FAILED);

const fetchEngagementUniqueViewersGraphReportSaga = function* (action: ReturnType<typeof fetchEngagementUniqueViewersGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/unique-viewers/graph`,
  });

  const fetchEngagementUniqueViewersGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementUniqueViewersGraphReportSagaAPI);
    yield put(fetchingEngagementUniqueViewersGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementUniqueViewersGraphReportFailed({ error: error }));
  }
};

//Fetching engagement share graph report 
export const fetchEngagementShareGraphReport = createAction<FetchEngagmentShareGraphRequest>(FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT);
const fetchingEngagementShareGraphReportSuccedded = createAction<FetchEngagmentShareGraphResponse>(FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_SUCCEDDED);
const fetchingEngagementShareGraphReportFailed = createAction<FetchEngagmentShareGraphErrorResponse>(FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT_FAILED);

const fetchEngagementShareGraphReportSaga = function* (action: ReturnType<typeof fetchEngagementShareGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/share/graph`,
  });

  const fetchEngagementShareGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementShareGraphReportSagaAPI);
    yield put(fetchingEngagementShareGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementShareGraphReportFailed({ error: error }));
  }
};

//Fetching engagement asset views graph
export const fetchEngagementAssetViewsGraphReport = createAction<FetchEngagementAssetViewsGraphRequest>(FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT);
const fetchingEngagementAssetViewsGraphReportSuccedded = createAction<FetchEngagementAssetViewsGraphResponse>(FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_SUCCEDDED);
const fetchingEngagementAssetViewsGraphReportFailed = createAction<FetchEngagementAssetViewsGraphErrorResponse>(FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT_FAILED);

const fetchEngagementAssetViewsGraphReportSaga = function* (action: ReturnType<typeof fetchEngagementAssetViewsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/asset_views/graph`,
  });

  const fetchEngagementAssetViewsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementAssetViewsGraphReportSagaAPI);
    yield put(fetchingEngagementAssetViewsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementAssetViewsGraphReportFailed({ error: error }));
  }
};

//Fetching engagement popular assets 
export const fetchEngagementPopularAssets = createAction<FetchEngagmentPopularAssetsRequest>(FETCHING_ENGAGEMENT_POPULAR_ASSETS);
const fetchingEngagementPopularAssetsSuccedded = createAction<FetchEngagmentPopularAssetsResponse>(FETCHING_ENGAGEMENT_POPULAR_ASSETS_SUCCEDDED);
const fetchingEngagementPopularAssetsFailed = createAction<FetchEngagmentPopularAssetsErrorResponse>(FETCHING_ENGAGEMENT_POPULAR_ASSETS_FAILED);

const fetchEngagementPopularAssetsSaga = function* (action: ReturnType<typeof fetchEngagementPopularAssets>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/popular-assets`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementPopularAssetsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementPopularAssetsSagaAPI);
    yield put(fetchingEngagementPopularAssetsSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementPopularAssetsFailed({ error: error }));
  }
};

//Fetching engagement top users 
export const fetchEngagementTopUsers = createAction<FetchEngagmentTopUsersRequest>(FETCHING_ENGAGEMENT_TOP_USERS);
const fetchingEngagementTopUsersSuccedded = createAction<FetchEngagmentTopUsersResponse>(FETCHING_ENGAGEMENT_TOP_USERS_SUCCEDDED);
const fetchingEngagementTopUsersFailed = createAction<FetchEngagmentTopUsersErrorResponse>(FETCHING_ENGAGEMENT_TOP_USERS_FAILED);

const fetchEngagementTopUsersSaga = function* (action: ReturnType<typeof fetchEngagementTopUsers>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/top-users`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementTopUsersSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementTopUsersSagaAPI);
    yield put(fetchingEngagementTopUsersSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementTopUsersFailed({ error: error }));
  }
};

//Fetching engagement top accounts 
export const fetchEngagementTopAccounts = createAction<FetchEngagementTopAccountsRequest>(FETCHING_ENGAGEMENT_TOP_ACCOUNTS);
const fetchingEngagementTopAccountsSuccedded = createAction<FetchEngagementTopAccountsResponse>(FETCHING_ENGAGEMENT_TOP_ACCOUNTS_SUCCEDDED);
const fetchingEngagementTopAccountsFailed = createAction<FetchEngagementTopAccountsErrorResponse>(FETCHING_ENGAGEMENT_TOP_ACCOUNTS_FAILED);

const fetchEngagementTopAccountsSaga = function* (action: ReturnType<typeof fetchEngagementTopAccounts>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/top-accounts`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementTopAccountsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementTopAccountsSagaAPI);
    yield put(fetchingEngagementTopAccountsSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementTopAccountsFailed({ error: error }));
  }
};

//Fetching engagement top campaigns
export const fetchEngagementCampaigns = createAction<FetchEngagementTopCampaignsRequest>(FETCHING_ENGAGEMENT_TOP_CAMPAIGNS);
const fetchingEngagementCampaignsSuccedded = createAction<FetchEngagementTopCampaignsResponse>(FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_SUCCEDDED);
const fetchingEngagementCampaignsFailed = createAction<FetchEngagementTopCampaignsErrorResponse>(FETCHING_ENGAGEMENT_TOP_CAMPAIGNS_FAILED);

const fetchEngagementCampaignsSaga = function* (action: ReturnType<typeof fetchEngagementCampaigns>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/campaigns`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementCampaignsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementCampaignsSagaAPI);
    yield put(fetchingEngagementCampaignsSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementCampaignsFailed({ error: error }));
  }
};

//Fetching engagement top campaign sources
export const fetchEngagementCampaignSources = createAction<FetchEngagementTopCampaignsSourcesRequest>(FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES);
const fetchingEngagementCampaignSourcesSuccedded = createAction<FetchEngagementTopCampaignsSourcesResponse>(FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_SUCCEDDED);
const fetchingEngagementCampaignSourcesFailed = createAction<FetchEngagementTopCampaignsSourcesErrorResponse>(FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES_FAILED);

const fetchEngagementCampaignSourceSaga = function* (action: ReturnType<typeof fetchEngagementCampaignSources>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/campaign-sources`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementCampaignSourceSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementCampaignSourceSagaAPI);
    yield put(fetchingEngagementCampaignSourcesSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementCampaignSourcesFailed({ error: error }));
  }
};

//Fetching engagement conversation activity
export const fetchEngagementShareReport = createAction<FetchEnagagementShareReportRequest>(FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES);
const fetchingEngagementShareReportSuccedded = createAction<FetchEnagagementShareReportResponse>(FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_SUCCEDDED);
const fetchingEngagementShareReportFailed = createAction<FetchEnagagementShareReportErrorResponse>(FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES_FAILED);

const fetchEngagementShareReportSaga = function* (action: ReturnType<typeof fetchEngagementShareReport>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/shares`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementShareReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementShareReportSagaAPI);
    yield put(fetchingEngagementShareReportSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementShareReportFailed({ error: error }));
  }
};

//Fetching engagement collection activity
export const fetchEngagementCollectionActivityReport = createAction<FetchEngagementCollectionReportRequest>(FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES);
const fetchingEngagementCollectionActivitiesSuccedded = createAction<FetchEngagementCollectionReportResponse>(FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_SUCCEDDED);
const fetchingEngagementCollectionActivitiesFailed = createAction<FetchEngagementCollectionReportErrorResponse>(FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES_FAILED);

const fetchEngagementCollectionActivityReportSaga = function* (action: ReturnType<typeof fetchEngagementCollectionActivityReport>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/collections`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementCollectionActivityReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementCollectionActivityReportSagaAPI);
    yield put(fetchingEngagementCollectionActivitiesSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementCollectionActivitiesFailed({ error: error }));
  }
};

//Fetching performance interactions graph 
export const fetchPerformanceInteractionsGraphReport = createAction<FetchPerformanceInteractionsGraphRequest>(FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT);
const fetchingPerformanceInteractionsGraphReportSuccedded = createAction<FetchPerformanceInteractionsGraphResponse>(FETCHING_PERFORMANCE_INTERACTIONS_SUCCEEDED);
const fetchingPerformanceInteractionsGraphReportFailed = createAction<FetchPerformanceInteractionsGraphErrorResponse>(FETCHING_PERFORMANCE_INTERACTIONS_FAILED);

const fetchPerformanceInteractionsGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceInteractionsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/interactions/graph`,
  });

  const fetchPerformanceInteractionsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceInteractionsGraphReportSagaAPI);
    yield put(fetchingPerformanceInteractionsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceInteractionsGraphReportFailed({ error: error }));
  }
};

//Fetching performance leads graph 
export const fetchPerformanceLeadsGraphReport = createAction<FetchPerformanceLeadsGraphRequest>(FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT);
const fetchingPerformanceLeadsGraphReportSuccedded = createAction<FetchPerformanceLeadsGraphResponse>(FETCHING_PERFORMANCE_LEADS_SUCCEEDED);
const fetchingPerformanceLeadsGraphReportFailed = createAction<FetchPerformanceLeadsGraphErrorResponse>(FETCHING_PERFORMANCE_LEADS_FAILED);

const fetchPerformanceLeadsGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceLeadsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/leads/graph`,
  });

  const fetchPerformanceLeadsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceLeadsGraphReportSagaAPI);
    yield put(fetchingPerformanceLeadsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceLeadsGraphReportFailed({ error: error }));
  }
};

//Fetching performance deals graph
export const fetchPerformanceDealsGraphReport = createAction<FetchPerformanceDealsGraphRequest>(FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT);
const fetchingPerformanceDealsGraphReportSuccedded = createAction<FetchPerformanceDealsGraphResponse>(FETCHING_PERFORMANCE_DEALS_SUCCEEDED);
const fetchingPerformanceDealsGraphReportFailed = createAction<FetchPerformanceDealsGraphErrorResponse>(FETCHING_PERFORMANCE_DEALS_FAILED);

const fetchPerformanceDealsGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceDealsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/deals/graph`,
  });

  const fetchPerformanceDealsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceDealsGraphReportSagaAPI);
    yield put(fetchingPerformanceDealsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceDealsGraphReportFailed({ error: error }));
  }
};

//Fetching performance deal value graph 
export const fetchPerformanceDealValueGraphReport = createAction<FetchPerformanceDealValueGraphRequest>(FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT);
const fetchingPerformanceDealValueGraphReportSuccedded = createAction<FetchPerformanceDealValueGraphResponse>(FETCHING_PERFORMANCE_DEAL_VALUE_SUCCEEDED);
const fetchingPerformanceDealValueGraphReportFailed = createAction<FetchPerformanceDealValueGraphErrorResponse>(FETCHING_PERFORMANCE_DEAL_VALUE_FAILED);

const fetchPerformanceDealValueGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceDealValueGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/dealValue/graph`,
  });

  const fetchPerformanceDealValueGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceDealValueGraphReportSagaAPI);
    yield put(fetchingPerformanceDealValueGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceDealValueGraphReportFailed({ error: error }));
  }
};

//Fetching performance closed deals graph
export const fetchPerformanceClosedDealsGraphReport = createAction<FetchPerformanceClosedDealGraphRequest>(FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT);
const fetchingPerformanceClosedDealsGraphReportSuccedded = createAction<FetchPerformanceClosedDealGraphResponse>(FETCHING_PERFORMANCE_CLOSED_DEALS_SUCCEEDED);
const fetchingPerformanceClosedDealsGraphReportFailed = createAction<FetchPerformanceClosedDealGraphErrorResponse>(FETCHING_PERFORMANCE_CLOSED_DEALS_FAILED);

const fetchPerformanceClosedDealsGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceClosedDealsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/closedDeals/graph`,
  });

  const fetchPerformanceClosedDealsGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceClosedDealsGraphReportSagaAPI);
    yield put(fetchingPerformanceClosedDealsGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceClosedDealsGraphReportFailed({ error: error }));
  }
};

//Fetching performance closed deal value graph
export const fetchPerformanceClosedDealValueGraphReport = createAction<FetchPerformanceClosedDealValueGraphRequest>(FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT);
const fetchingPerformanceClosedDealValueGraphReportSuccedded = createAction<FetchPerformanceClosedDealValueGraphResponse>(FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_SUCCEEDED);
const fetchingPerformanceClosedDealValueGraphReportFailed = createAction<FetchPerformanceClosedDealValueGraphErrorResponse>(FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_FAILED);

const fetchPerformanceClosedDealValueGraphReportSaga = function* (action: ReturnType<typeof fetchPerformanceClosedDealValueGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/closedDealValue/graph`,
  });

  const fetchPerformanceClosedDealValueGraphReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceClosedDealValueGraphReportSagaAPI);
    yield put(fetchingPerformanceClosedDealValueGraphReportSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceClosedDealValueGraphReportFailed({ error: error }));
  }
};

//Fetching performance top leads content
export const fetchPerformanceTopContentGeneratingLeads = createAction<FetchPerformanceTopContentLeadsRequest>(FETCHING_PERFORMANCE_TOP_LEADS_CONTENT);
const fetchingPerformanceTopContentGeneratingLeadsSuccedded = createAction<FetchPerformanceTopContentLeadsResponse>(FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_SUCCEDDED);
const fetchingPerformanceTopContentGeneratingLeadsFailed = createAction<FetchPerformanceTopContentLeadsErrorResponse>(FETCHING_PERFORMANCE_TOP_LEADS_CONTENT_FAILED);

const fetchPerformanceTopContentGeneratingLeadsSaga = function* (action: ReturnType<typeof fetchPerformanceTopContentGeneratingLeads>): any {
  const { page, limit, filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/top-leads-content`,
  });

  const params = {
    page: page,
    limit: limit,
  };


  const fetchPerformanceTopContentGeneratingLeadsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceTopContentGeneratingLeadsSagaAPI);
    yield put(fetchingPerformanceTopContentGeneratingLeadsSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceTopContentGeneratingLeadsFailed({ error: error }));
  }
};

//Fetching performance content closed deals 
export const fetchPerformanceTopContentClosedDeals = createAction<any>(FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS);
const fetchingPerformanceTopContentClosedDealsSuccedded = createAction<any>(FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_SUCCEDDED);
const fetchingPerformanceTopContentClosedDealsFailed = createAction<any>(FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS_FAILED);

const fetchPerformanceTopContentClosedDealsSaga = function* (action: ReturnType<typeof fetchPerformanceTopContentClosedDeals>): any {
  const { page, limit, filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/top-content-closed-deals`,
  });

  const params = {
    page: page,
    limit: limit,
  };


  const fetchPerformanceTopContentClosedDealsSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchPerformanceTopContentClosedDealsSagaAPI);
    yield put(fetchingPerformanceTopContentClosedDealsSuccedded(response));
  } catch (error) {
    yield put(fetchingPerformanceTopContentClosedDealsFailed({ error: error }));
  }
};

//Fetching performance leads detail report 
export const fetchLeadsDetailReport = createAction<any>(FETCHING_LEADS_DETAIL_REPORT);
const fetchingLeadsDetailReportSuccedded = createAction<any>(FETCHING_LEADS_DETAIL_REPORT_SUCCEEDED);
const fetchingLeadsDetailReportFailed = createAction<any>(FETCHING_LEADS_DETAIL_REPORT_FAILED);

const fetchLeadsDetailReportSaga = function* (action: ReturnType<typeof fetchLeadsDetailReport>): any {
  const { page, limit, filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/leads/detail`,
  });

  const params = {
    page: page,
    limit: limit,
  };


  const fetchLeadsDetailReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchLeadsDetailReportSagaAPI);
    yield put(fetchingLeadsDetailReportSuccedded(response));
  } catch (error) {
    yield put(fetchingLeadsDetailReportFailed({ error: error }));
  }
};

//Fetching performance deals detail report 
export const fetchDealsDetailReport = createAction<any>(FETCHING_DEALS_REQUEST_DETAIL_REPORT);
const fetchingDealsDetailReportSuccedded = createAction<any>(FETCHING_DEALS_REQUEST_DETAIL_REPORT_SUCCEEDED);
const fetchingDealsDetailReportFailed = createAction<any>(FETCHING_DEALS_REQUEST_DETAIL_REPORT_FAILED);

const fetchDealsDetailReportSaga = function* (action: ReturnType<typeof fetchDealsDetailReport>): any {
  const { page, limit, filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/deals/detail`,
  });

  const params = {
    page: page,
    limit: limit,
  };


  const fetchDealsDetailReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDealsDetailReportSagaAPI);
    yield put(fetchingDealsDetailReportSuccedded(response));
  } catch (error) {
    yield put(fetchingDealsDetailReportFailed({ error: error }));
  }
};

//Fetching performance closed deals detail report
export const fetchClosedDealsDetailReport = createAction<any>(FETCHING_CLOSED_DEALS_DETAIL_REPORT);
const fetchingClosedDealsDetailReportSuccedded = createAction<any>(FETCHING_CLOSED_DEALS_DETAIL_REPORT_SUCCEEDED);
const fetchingClosedDealsDetailReportFailed = createAction<any>(FETCHING_CLOSED_DEALS_DETAIL_REPORT_FAILED);

const fetchClosedDealsDetailReportSaga = function* (action: ReturnType<typeof fetchClosedDealsDetailReport>): any {
  const { page, limit, filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `performance/closedDeals/detail`,
  });

  const params = {
    page: page,
    limit: limit,
  };


  const fetchClosedDealsDetailReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchClosedDealsDetailReportSagaAPI);
    yield put(fetchingClosedDealsDetailReportSuccedded(response));
  } catch (error) {
    yield put(fetchingClosedDealsDetailReportFailed({ error: error }));
  }
};

//initializing download reports 
export const intializeDownloadReport = createAction<any>(INTIALIZING_DOWNLOAD_REPORT_REQUEST);
const initializingDownloadReportSuccedded = createAction<any>(INTIALIZING_DOWNLOAD_REPORT_SUCCEDDED);
const initializingDownloadReportFailed = createAction<any>(INTIALIZING_DOWNLOAD_REPORT_FAILED);

const intializeDownloadReportSaga = function* (action: ReturnType<typeof intializeDownloadReport>): any {
  const { id, page, limit, request } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `/download/${id}/data`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const intializeDownloadReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: request
    }).then((response) => response.data);
  };

  try {
    const response = yield call(intializeDownloadReportSagaAPI);
    yield put(initializingDownloadReportSuccedded(response));
  } catch (error) {
    yield put(initializingDownloadReportFailed({ error: error }));
  }
};

export const invalidateReportsDownloadData = createAction<void>(INVALIDATE_REPORTS_DOWNLOAD_DATA);

// fetching advocacy time spent
export const fetchAdvocacyTimeSpentGraphReport = createAction<FetchAdvocacyTimeSpentGraphReport>(FETCH_ADVOCACY_TIME_SPENT);
const fetchingAdvocacyTimeSpentGraphReportSucceeded = createAction<FetchingAdvocacyTimeSpentGraphReportSucceeded>(FETCHING_ADVOCACY_TIME_SPENT_SUCCEEDED);
const fetchingAdvocacyTimeSpentGraphReportFailed = createAction<FetchingAdvocacyTimeSpentGraphReportFailed>(FETCHING_ADVOCACY_TIME_SPENT_FAILED);

const fetchAdvocacyTimeSpentGraphReportSaga = function* (action: ReturnType<typeof fetchAdvocacyTimeSpentGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/time-spent/graph`,
  });

  const fetchAdvocacyTimeSpentGraphReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyTimeSpentGraphReportAPI);
    yield put(fetchingAdvocacyTimeSpentGraphReportSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyTimeSpentGraphReportFailed({ error: error }));
  }
};

//Fetching advocacy views graph 
export const fetchAdvocacyViewsGraphReport = createAction<FetchAdvocacyViewsGraphReportRequest>(FETCH_ADVOCACY_VIEWS);
const fetchingAdvocacyViewsGraphReportSucceeded = createAction<FetchingAdvocacyViewsGraphReportSucceeded>(FETCHING_ADVOCACY_VIEWS_SUCCEEDED);
const fetchingAdvocacyViewsGraphReportFailed = createAction<FetchingAdvocacyViewsGraphReportFailed>(FETCHING_ADVOCACY_VIEWS_FAILED);

const fetchAdvocacyViewsGraphReportSaga = function* (action: ReturnType<typeof fetchAdvocacyViewsGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/asset-views/graph`,
  });

  const fetchAdvocacyViewsGraphReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyViewsGraphReportAPI);
    yield put(fetchingAdvocacyViewsGraphReportSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyViewsGraphReportFailed({ error: error }));
  }
};

//Fetching advocacy shares graph 
export const fetchAdvocacyShareGraphReport = createAction<FetchAdvocacyShareGraphReportRequest>(FETCH_ADVOCACY_SHARES);
const fetchingAdvocacyShareGraphReportSucceeded = createAction<FetchAdvocacyShareGraphReportResponse>(FETCHING_ADVOCACY_SHARES_SUCCEEDED);
const fetchingAdvocacyShareGraphReportFailed = createAction<FetchAdvocacyShareGraphReportErrorResponse>(FETCHING_ADVOCACY_SHARES_FAILED);

const fetchAdvocacyShareGraphReportSaga = function* (action: ReturnType<typeof fetchAdvocacyShareGraphReport>): any {
  const { filter } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/shares/graph`,
  });

  const fetchAdvocacyShareGraphReportAPI = () => {
    return axios({
      method: "POST",
      url: url,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyShareGraphReportAPI);
    yield put(fetchingAdvocacyShareGraphReportSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyShareGraphReportFailed({ error: error }));
  }
};

// Fetching advocacy top shared assets
export const fetchAdvocacyTopSharedAssets = createAction<FetchAdvocacyTopSharedAssetsRequest>(FETCH_ADVOCACY_TOP_SHARED_ASSETS);
const fetchingAdvocacyTopSharedAssetsSucceeded = createAction<FetchAdvocacyTopSharedAssetsResponse>(FETCHING_ADVOCACY_TOP_SHARED_ASSETS_SUCCEEDED);
const fetchingAdvocacyTopSharedAssetsFailed = createAction<FetchAdvocacyTopSharedAssetsErrorResponse>(FETCHING_ADVOCACY_TOP_SHARED_ASSETS_FAILED);

const fetchAdvocacyTopSharedAssetsSaga = function* (action: ReturnType<typeof fetchAdvocacyTopSharedAssets>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/top-shared-assets`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchAdvocacyTopSharedAssetsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyTopSharedAssetsAPI);
    yield put(fetchingAdvocacyTopSharedAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyTopSharedAssetsFailed({ error: error }));
  }
};

// Fetching advocacy top engaged assets
export const fetchAdvocacyTopEngagedAssets = createAction<FetchAdvocacyTopEngagedAssetsRequest>(FETCH_ADVOCACY_TOP_ENGAGED_ASSETS);
const fetchingAdvocacyTopEngagedAssetsSucceeded = createAction<FetchAdvocacyTopEngagedAssetsResponse>(FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_SUCCEEDED);
const fetchingAdvocacyTopEngagedAssetsFailed = createAction<FetchAdvocacyTopEngagedAssetsErrorResponse>(FETCHING_ADVOCACY_TOP_ENGAGED_ASSETS_FAILED);

const fetchAdvocacyTopEngagedAssetsSaga = function* (action: ReturnType<typeof fetchAdvocacyTopEngagedAssets>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/top-engaged-assets`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchAdvocacyTopEngagedAssetsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyTopEngagedAssetsAPI);
    yield put(fetchingAdvocacyTopEngagedAssetsSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyTopEngagedAssetsFailed({ error: error }));
  }
};

// Fetching advocacy top sharers
export const fetchAdvocacyTopSharers = createAction<FetchAdvocacyTopSharersRequest>(FETCH_ADVOCACY_TOP_SHARERS);
const fetchingAdvocacyTopSharersSucceeded = createAction<FetchAdvocacyTopSharersResponse>(FETCHING_ADVOCACY_TOP_SHARERS_SUCCEEEDED);
const fetchingAdvocacyTopSharersFailed = createAction<FetchAdvocacyTopSharersErrorResponse>(FETCHING_ADVOCACY_TOP_SHARERS_FAILED);

const fetchAdvocacyTopSharersSaga = function* (action: ReturnType<typeof fetchAdvocacyTopSharers>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/top-sharers`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchAdvocacyTopSharersAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyTopSharersAPI);
    yield put(fetchingAdvocacyTopSharersSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyTopSharersFailed({ error: error }));
  }
};

//Fetching advocacy top user groups 
export const fetchAdvocacyTopUserGroups = createAction<FetchAdvocacyTopUserGroupsRequest>(FETCH_ADVOCACY_TOP_USER_GROUPS);
const fetchingAdvocacyTopUserGroupsSucceeded = createAction<FetchAdvocacyTopUserGroupsResponse>(FETCHING_ADVOCACY_TOP_USER_GROUPS_SUCCEEDED);
const fetchingAdvocacyTopUserGroupsFailed = createAction<FetchAdvocacyTopUserGroupsErrorResponse>(FETCHING_ADVOCACY_TOP_USER_GROUPS_FAILED);

const fetchAdvocacyTopUserGroupsSaga = function* (action: ReturnType<typeof fetchAdvocacyTopUserGroups>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `advocacy/top-user-groups`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchAdvocacyTopUserGroupsAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchAdvocacyTopUserGroupsAPI);
    yield put(fetchingAdvocacyTopUserGroupsSucceeded(response));
  } catch (error) {
    yield put(fetchingAdvocacyTopUserGroupsFailed({ error: error }));
  }
};

export const fetchDiscoveryDealrooms = createAction<FetchDiscoveryDealRoomsRequest>(FETCHING_DISCOVERY_DEAL_ROOMS_REPORT);
const fetchingDiscoveryDealroomsSuccedded = createAction<FetchDiscoveryDealRoomsResponse>(FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_SUCCEEDED);
const fetchingDiscoveryDealroomsFailed = createAction<FetchDiscoveryDealRoomsErrorResponse>(FETCHING_DISCOVERY_DEAL_ROOMS_REPORT_FAILED);

const fetchDiscoveryDealRoomsSaga = function* (action: ReturnType<typeof fetchDiscoveryDealrooms>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/deal-rooms`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryDealRoomsSagaAPI = () => {
    return axios({
      method: "POST",
      url : url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryDealRoomsSagaAPI);
    yield put(fetchingDiscoveryDealroomsSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryDealroomsFailed({ error: error }));
  }
};
//Fetching discovery collections shared
export const fetchDiscoveryDealRoomsShared = createAction<FetchDiscoveryDealRoomsSharedRequest>(FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT);
const fetchingDiscoveryDealRoomsSharedSuccedded = createAction<FetchDiscoveryDealRoomsSharedResponse>(FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_SUCCEDDED);
const fetchingDiscoveryDealRoomsSharedFailed = createAction<FetchDiscoveryDealRoomsSharedErrorResponse>(FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT_FAILED);

const fetchDiscoveryDealRoomsSharedSaga = function* (action: ReturnType<typeof fetchDiscoveryDealRoomsShared>): any {
  const { page, filter, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `discovery/deal-rooms-shared`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchDiscoveryDealRoomsSharedSagaAPI = () => {
    return axios({
      method: "POST", 
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDiscoveryDealRoomsSharedSagaAPI);
    yield put(fetchingDiscoveryDealRoomsSharedSuccedded(response));
  } catch (error) {
    yield put(fetchingDiscoveryDealRoomsSharedFailed({ error: error }));
  }
};

//Fetching engagement collection activity
export const fetchEngagementDealRoomActivityReport = createAction<FetchEngagementDealRoomReportRequest>(FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES);
const fetchingEngagementDealRoomActivitiesSuccedded = createAction<FetchEngagementDealRoomReportResponse>(FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_SUCCEDDED);
const fetchingEngagementDealRoomActivitiesFailed = createAction<FetchEngagementDealRoomReportErrorResponse>(FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES_FAILED);

const fetchEngagementDealRoomActivityReportSaga = function* (action: ReturnType<typeof fetchEngagementDealRoomActivityReport>): any {
  const { filter, page, limit } = action.payload;

  const url = buildUrl(REPORT_BASE_URL, {
    path: `engagement/deal-rooms`,
  });

  const params = {
    page: page,
    limit: limit,
  };

  const fetchEngagementDealRoomActivityReportSagaAPI = () => {
    return axios({
      method: "POST",
      url: url,
      params: params,
      data: filter
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchEngagementDealRoomActivityReportSagaAPI);
    yield put(fetchingEngagementDealRoomActivitiesSuccedded(response));
  } catch (error) {
    yield put(fetchingEngagementDealRoomActivitiesFailed({ error: error }));
  }
};

export default function* reportsSaga() {
  yield takeEvery(FETCHING_DISCOVERY_POPULAR_ASSETS, fetchDiscoveryPopularAssetsSaga);
  yield takeEvery(FETCHING_ACCOUNT_SUMMARY_NUDGES_REQUEST, fetchReportsSummaryNudgesSaga);
  yield takeEvery(FETCHING_DISCOVERY_ASSETS_SHARED_REPORT, fetchDiscoverAssetsSharedSaga);
  yield takeEvery(FETCHING_DISCOVERY_TOP_USERS, fetchDiscoveryTopUsersSaga);
  yield takeEvery(FETCHING_DISCOVERY_TOP_SHARERS, fetchDiscoveryTopSharesSaga);
  yield takeEvery(FETCHING_DISCOVERY_TOP_USER_GROUPS, fetchDiscoveryTopUserGroupsSaga);
  yield takeEvery(FETCHING_DISCOVERY_COLLECTIONS_REPORT, fetchDiscoveryCollectionsSaga);
  yield takeEvery(FETCHING_DISCOVERY_COLLECTIONS_SHARED_REPORT, fetchDiscoveryCollectionsSharedSaga);
  yield takeEvery(FETCHING_DISCOVERY_SEARCH_QUERIES, fetchDiscoverySearchQueriesSaga);
  yield takeEvery(FETCHING_DISCOVERY_SEARCH_TAGS, fetchDiscoverySearchTagsSaga);
  yield takeEvery(FETCHING_DISCOVERY_ASSET_VIEWS_GRAPH_REPORT, fetchDiscoveryAssetViewsGraphReportSaga);
  yield takeEvery(FETCHING_DISCOVERY_ASSET_GRAPH_REPORT, fetchDiscoveryAssetsGraphReportSaga);
  yield takeEvery(FETCHING_DISCOVERY_COLLECTION_ACTIVITY_GRAPH_REPORT, fetchDiscoveryCollectionActivityGraphReportSaga);
  yield takeEvery(FETCHING_DISCOVERY_SHARE_GRAPH_REPORT, fetchDiscoveryShareGraphReportSaga);
  yield takeEvery(FETCHING_DISCOVERY_CONTENT_MATRIX_ASSETS_REQUEST, fetchDiscoveryContentMatrxAssetsSaga);
  yield takeEvery(FETCHING_DISCOVERY_CONTENT_MATRIX_REQUEST, fetchDiscoveryContentMatrixSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_ATTENTION_TIME_GRAPH_REPORT, fetchEngagementAttentionTimeGraphReportSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_UNIQUE_VIEWERS_GRAPH_REPORT, fetchEngagementUniqueViewersGraphReportSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_SHARE_GRAPH_REPORT, fetchEngagementShareGraphReportSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_ASSET_VIEWS_GRAPH_REPORT, fetchEngagementAssetViewsGraphReportSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_POPULAR_ASSETS, fetchEngagementPopularAssetsSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_TOP_USERS, fetchEngagementTopUsersSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_TOP_ACCOUNTS, fetchEngagementTopAccountsSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_TOP_CAMPAIGNS, fetchEngagementCampaignsSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_TOP_CAMPAIGN_SOURCES, fetchEngagementCampaignSourceSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_CONVERSATION_ACTIVITIES, fetchEngagementShareReportSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_COLLECTION_ACTIVITIES, fetchEngagementCollectionActivityReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_INTERACTIONS_GRAPH_REPORT, fetchPerformanceInteractionsGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_LEADS_GRAPH_REPORT, fetchPerformanceLeadsGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_DEALS_GRAPH_REPORT, fetchPerformanceDealsGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_DEAL_VALUE_GRAPH_REPORT, fetchPerformanceDealValueGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_CLOSED_DEALS_GRAPH_REPORT, fetchPerformanceClosedDealsGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_CLOSED_DEAL_VALUE_GRAPH_REPORT, fetchPerformanceClosedDealValueGraphReportSaga);
  yield takeEvery(FETCHING_PERFORMANCE_TOP_LEADS_CONTENT, fetchPerformanceTopContentGeneratingLeadsSaga);
  yield takeEvery(FETCHING_PERFORMANCE_TOP_CONTENT_CLOSED_DEALS, fetchPerformanceTopContentClosedDealsSaga);
  yield takeEvery(FETCHING_LEADS_DETAIL_REPORT, fetchLeadsDetailReportSaga);
  yield takeEvery(FETCHING_DEALS_REQUEST_DETAIL_REPORT, fetchDealsDetailReportSaga);
  yield takeEvery(FETCHING_CLOSED_DEALS_DETAIL_REPORT, fetchClosedDealsDetailReportSaga);
  yield takeEvery(INTIALIZING_DOWNLOAD_REPORT_REQUEST, intializeDownloadReportSaga);
  
  yield takeEvery(FETCH_ADVOCACY_TIME_SPENT, fetchAdvocacyTimeSpentGraphReportSaga);
  yield takeEvery(FETCH_ADVOCACY_VIEWS, fetchAdvocacyViewsGraphReportSaga);
  yield takeEvery(FETCH_ADVOCACY_SHARES, fetchAdvocacyShareGraphReportSaga);
  yield takeEvery(FETCH_ADVOCACY_TOP_SHARED_ASSETS, fetchAdvocacyTopSharedAssetsSaga);
  yield takeEvery(FETCH_ADVOCACY_TOP_ENGAGED_ASSETS, fetchAdvocacyTopEngagedAssetsSaga);
  yield takeEvery(FETCH_ADVOCACY_TOP_SHARERS, fetchAdvocacyTopSharersSaga);
  yield takeEvery(FETCH_ADVOCACY_TOP_USER_GROUPS, fetchAdvocacyTopUserGroupsSaga);
  yield takeEvery(FETCHING_DISCOVERY_DEAL_ROOMS_REPORT, fetchDiscoveryDealRoomsSaga);
  yield takeEvery(FETCHING_DISCOVERY_DEAL_ROOMS_SHARED_REPORT, fetchDiscoveryDealRoomsSharedSaga);
  yield takeEvery(FETCHING_ENGAGEMENT_DEAL_ROOMS_ACTIVITIES, fetchEngagementDealRoomActivityReportSaga);
}